export default "/assets/images/quiet-mode.e967e1e1c54ba8c7.mp4";